import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
// Design system: tokens+base first, then theme overrides, utilities,
// components; motion last so its reduced-motion kill switch wins the cascade.
import './index.css';
import './styles/themes.css';
import './styles/utilities.css';
import './styles/components.css';
import './styles/motion.css';
import App from './App';
import BuildFreshness from './components/BuildFreshness';
import { APP_NAME } from './data/kitEnv';
import { AuthProvider } from './AuthContext';
import { TenantProvider } from './TenantContext';
import { ToastProvider } from './components/Toast';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <TenantProvider>
          <ToastProvider>
            <App />
            {/* "A newer version is ready" — stale-tab detection (utils/buildFreshness.js). */}
            <BuildFreshness name={APP_NAME} />
          </ToastProvider>
        </TenantProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
